import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { supabase } from '../supabase/client';
import { setSelfTests, loadSelfTestsFromCache } from '../Redux/ovulationTestsSlice';
import { incrementOperation, decrementOperation } from '../Redux/loadingSlice';

const TAG = '[TestsLoader]';

/**
 * TestsLoader - Loads self tests on app start
 * 1. Load from localStorage cache first
 * 2. Then fetch from Supabase
 * 3. Store in Redux
 * Uses global loading indicator
 */
function TestsLoader() {
  const dispatch = useDispatch();
  const authUserId = useSelector((s) => s.user.authUserId);

  useEffect(() => {
    if (!authUserId) {
      return;
    }

    const loadSelfTests = async () => {
      // Load from cache first
      dispatch(loadSelfTestsFromCache());

      // Show global loading indicator
      dispatch(incrementOperation('testsLoad'));

      try {
        const { data, error } = await supabase
          .from('ovulation_tests')
          .select('*')
          .eq('user_id', authUserId)
          .order('taken_at', { ascending: false });

        if (!error && data) {
          dispatch(setSelfTests(data));
        }
      } catch (err) {
      } finally {
        // Hide global loading indicator
        dispatch(decrementOperation('testsLoad'));
      }
    };

    loadSelfTests();
  }, [authUserId, dispatch]);

  return null;
}

export default TestsLoader;
